document.querySelectorAll('.event-gallery-trigger').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
        e.preventDefault();
        var card = btn.closest('.event-card');
        card.querySelector('.post-slider .carousel a:first-child').click();
    });
});